import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthComponent } from './auth.component';

const routes: Routes = [
    {
      path: '',
      component: AuthComponent,
      data: {
            title: 'Auth'
        }
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth-routing.module.ts